import Collection from './Collection';
import Div from './Div';
import H1 from './H1';
import Image from './Image';
import Italic from './Italic';
import Link from './Link';
import List from './List';
import P from './P';
import Span from './Span';

export { Collection, Div, H1, Image, Italic, Link, List, P, Span };
